<template>
  <div>
    <AppSkeletonMenu>
      <template v-slot>
        <CollectionsContainer />
      </template>
    </AppSkeletonMenu>
    <LoginPopUp v-if="!isLoggedIn" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import AppSkeletonMenu from '@/components/Skeleton/AppSkeletonMenu.vue';
import CollectionsContainer from '@/components/Collections/CollectionsContainer.vue';
import LoginPopUp from '@/components/PopUps/LoginPopUp.vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'Collections',
  components: {
    AppSkeletonMenu,
    CollectionsContainer,
    LoginPopUp,
  },
  setup() {
    const store = useStore();
    const isLoggedIn = computed(() => store.getters['auth/isLoggedIn']);
    return { isLoggedIn };
  },
});
</script>
